// Jump-to pills: collapse to N rows and reveal the rest on demand.
//
// Rows are worked out from each pill's offsetTop rather than a fixed count,
// so wrapping stays correct at any width, font size or pill length. Recomputed
// on resize because the number of pills per row changes with the viewport.

function initJumpTo(root) {
  if (root.dataset.jumpToInit) return;
  root.dataset.jumpToInit = '1';

  const list = root.querySelector('[data-jump-list]');
  const toggle = root.querySelector('[data-jump-toggle]');
  const label = root.querySelector('[data-jump-toggle-label]');
  if (!list || !toggle) return;

  const items = Array.prototype.slice.call(list.querySelectorAll('.jump-to__item'));
  const maxRows = parseInt(root.dataset.visibleRows || '2', 10);
  const moreLabel = toggle.dataset.labelMore || 'Show more';
  const lessLabel = toggle.dataset.labelLess || 'Show less';

  let expanded = false;

  function apply() {
    // Measure with everything visible, otherwise hidden pills report offsetTop 0.
    items.forEach(function (el) {
      el.classList.remove('jump-to__item--hidden');
    });

    if (expanded) {
      toggle.hidden = false;
      toggle.setAttribute('aria-expanded', 'true');
      if (label) label.textContent = lessLabel;
      return;
    }

    const tops = [];
    let hiddenCount = 0;

    items.forEach(function (el) {
      const top = el.offsetTop;
      if (tops.indexOf(top) === -1) tops.push(top);
      // Row index is this pill's position in the list of distinct offsets.
      if (tops.indexOf(top) >= maxRows) {
        el.classList.add('jump-to__item--hidden');
        hiddenCount++;
      }
    });

    toggle.hidden = hiddenCount === 0;
    toggle.setAttribute('aria-expanded', 'false');
    if (label) label.textContent = moreLabel;
  }

  toggle.addEventListener('click', function () {
    expanded = !expanded;
    apply();
  });

  let frame = null;
  window.addEventListener('resize', function () {
    if (frame) cancelAnimationFrame(frame);
    frame = requestAnimationFrame(apply);
  });

  apply();
}

function bootJumpTo(scope) {
  (scope || document).querySelectorAll('[data-jump-to]').forEach(initJumpTo);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function () {
    bootJumpTo();
  });
} else {
  bootJumpTo();
}

document.addEventListener('shopify:section:load', function (e) {
  bootJumpTo(e.target);
});
